module.exports = __webpack_public_path__ + "img/thai-curry-1.4ca41357.jpg";